import React from 'react';
import NotFound from '../pages/Page404';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: '' };
  }

  componentDidCatch(error) {
    this.setState({ error: `${error.name}: ${error.message}` });
  }

  render() {
    const { error } = this.state;

    if (error) {
      return <NotFound />;
    }

    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
